import { createFragmentContainer, graphql } from "react-relay";
import JobEvent from "~/components/JobActivityTimeline/JobEvent";

type Props = {
  event: any;
  previousTimestamp: string | null | undefined;
};

function JobEventReservedExpired({ event, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>Job reservation expired</JobEvent.Label>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventReservedExpired, {
  event: graphql`
    fragment JobEventReservedExpired_event on JobEvent {
      ... on JobEvent {
        timestamp
      }
    }
  `,
});
